import type * as React from 'react'

import { cn } from './cn'

const INPUT_CLASS_NAME =
  'h-9 w-full min-w-0 rounded-lg border border-border bg-transparent px-3 py-1 text-base outline-none transition-[color,box-shadow,border-color] duration-100 selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:font-medium file:text-foreground file:text-sm placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm focus-visible:border-ring/45 focus-visible:ring-1 focus-visible:ring-ring/25 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40'

type InputProps = React.ComponentProps<'input'>

function Input({ className, type, ...props }: InputProps) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(INPUT_CLASS_NAME, className)}
      {...props}
    />
  )
}

export type { InputProps }
export { INPUT_CLASS_NAME, Input }
